<div class="grid col-9">
    @if (isHeaderShown) {
        <div class="col-10">
            <!-- <p-message severity="info" text="{{titleHeader}}"></p-message> -->
            <p-message styleClass="wal-header-message">{{titleHeader}}</p-message>
        </div>
    }
    <div class="col-1">
        @if(isBrandLogoImageShown) {
            <div><img class="center-block" [src]="brandLogoImage" /></div>
        }
    </div>
</div>
